import api from "./api";

// publish news
export const insertNews = async (formData) => {
    try {
        const response = await api.post(`/api/v1/watoms/news`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data?.data || [];
    } catch (error) {
        console.error(
            "Error inserting news:",
            error.response?.data || error.message
        );
        throw error;
    }
};

// view news
export const viewNews = async () => {
    try {
        const response = await api.get(`/api/v1/watoms/news`);
        return response.data?.data || [];
    } catch (error) {
        console.error(
            "Error fetching news:",
            error.response?.data || error.message
        );
        throw error;
    }
};

// update news notification
export const updateNewsNotification = async (newsId, notificationData) => {
    try {
        const response = await api.put(`/api/v1/watoms/news/${newsId}/notification`, notificationData);
        return response.data?.data || response.data;
    } catch (error) {
        console.error(
            "Error updating news notification:",
            error.response?.data || error.message
        );
        throw error;
    }
};

// get news images for slideshow
export const getNewsImages = async (newsId) => {
    try {
        const response = await api.get(`/api/v1/watoms/news/${newsId}/images`);
        // Handle both response.data.images and response.data.data.images
        return response.data?.images || response.data?.data?.images || [];
    } catch (error) {
        // If 404, return empty array instead of throwing
        if (error.response?.status === 404) {
            console.warn(`News images not found for news ID ${newsId}:`, error.response?.data || error.message);
            return [];
        }
        console.error(
            "Error fetching news images:",
            error.response?.data || error.message
        );
        throw error;
    }
};

// add additional image to existing news item
export const addNewsImage = async (newsId, formData) => {
    try {
        const response = await api.post(`/api/v1/watoms/news/${newsId}/images`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (error) {
        console.error(
            "Error adding news image:",
            error.response?.data || error.message
        );
        throw error;
    }
};

// add test images to news (for testing slideshow)
export const addTestImagesToNews = async (newsId, count = 3) => {
    try {
        const response = await api.post(`/api/v1/watoms/news/${newsId}/test-images`, { count });
        return response.data;
    } catch (error) {
        console.error(
            "Error adding test images:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const editExistingCourse = async (id, data) => {
    try {
        const response = await api.patch(`/api/v1/admin/edit-class/${id}`, data);
        return response.data;
    } catch (error) {
        console.error(
            "Error adding test images:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const deleteExistingCourse = async (id) => {
    try {
        const response = await api.delete(`/api/v1/admin/delete-class/${id}`);
        return response.data;
    } catch (error) {
        console.error(
            "Error adding test images:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const editExistingClassRoom = async (id, data) => {
    try {
        const response = await api.patch(`/api/v1/admin/edit-classroom/${id}`, data);
        return response.data;
    } catch (error) {
        console.error(
            "Error adding test images:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const createClassRoom = async (data) => {
    try {
        const response = await api.post(`/api/v1/admin/create-new-classroom`, data);
        return response.data.newClassRoom;
    } catch (error) {
        console.error(
            "Error adding test images:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const uploadClassRoomDocument = async (formData) => {
    try {
        const response = await api.post(`/api/v1/admin/classroom-upload`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (error) {
        console.error(
            "Error uploading classroom document:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const createClass = async (data) => {
    try {
        const response = await api.post(`/api/v1/admin/create-new-class`, data);
        return response.data.newClass;
    } catch (error) {
        console.error(
            "Error adding test images:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const uploadUserImage = async (formData) => {
    try {
        const response = await api.post(`/api/v1/admin/user-upload-image`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
        return response.data;
    } catch (error) {
        console.error(
            "Error uploading classroom document:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const assignTeacherToClasses = async (data) => {
    try {
        const response = await api.post(`/api/v1/admin/assign-teacher-to-class`, data);
        return response.data;
    } catch (error) {
        console.error(
            "Error assigning teacher to classes:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const updateTeacherSubject = async (data) => {
    try {
        const response = await api.post(`/api/v1/wisdom/teacher-subject`, data);
        return response.data;
    } catch (error) {
        console.error(
            "Error assigning teacher to subjects:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const getUserRolesPermissions = async () => {
    try {
        const response = await api.get(`/api/v1/admin/user-roles-permissions`, );
        return response.data.roles;
    } catch (error) {
        console.error(
            "Error assigning teacher to classes:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const getPagesData = async () => {
    try {
        const response = await api.get(`/api/v1/data/pages`, );
        return response.data.pages;
    } catch (error) {
        console.error(
            "Error assigning teacher to classes:",
            error.response?.data || error.message
        );
        throw error;
    }
};

export const giveRolePermissions = async (data) => {
    try {
        const response = await api.post(`/api/v1/admin/role-permissions`, data);
        return response.data.permissions;
    } catch (error) {
        console.error(
            "Error assigning teacher to classes:",
            error.response?.data || error.message
        );
        throw error;
    }
};